// extracted by mini-css-extract-plugin
export default {"status":"styles_status__pwspi","complete":"styles_complete__J6WF4","suspended":"styles_suspended__geQfO","canceled":"styles_canceled__X2p6z","autorepeat":"styles_autorepeat__lPRC4"};